import { Button, Progress, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const UploadInput = styled.div`
  width: 100%;
`;

const UploadWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const UploadArea = styled.div`
  align-items: center;
  background: var(--color-bg-body);

  background-image: repeating-linear-gradient(
      0deg,
      ${({ hasError }) =>
        hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'},
      ${({ hasError }) =>
          hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'}
        18px,
      transparent 18px,
      transparent 36px
    ),
    repeating-linear-gradient(
      90deg,
      ${({ hasError }) =>
        hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'},
      ${({ hasError }) =>
          hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'}
        18px,
      transparent 18px,
      transparent 36px
    ),
    repeating-linear-gradient(
      180deg,
      ${({ hasError }) =>
        hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'},
      ${({ hasError }) =>
          hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'}
        18px,
      transparent 18px,
      transparent 36px
    ),
    repeating-linear-gradient(
      270deg,
      ${({ hasError }) =>
        hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'},
      ${({ hasError }) =>
          hasError ? 'var(--color-error-default)' : 'var(--color-accent-secondary-weaker)'}
        18px,
      transparent 18px,
      transparent 36px
    );

  background-position:
    0 0,
    0 0,
    100% 0,
    0 100%;
  background-repeat: no-repeat;
  background-size:
    3px 100%,
    100% 3px,
    3px 100%,
    100% 3px;
  border-radius: var(--size-border-radius-xl);
  cursor: pointer;
  display: flex;
  height: 240px;
  justify-content: center;
  margin-bottom: 16px;
  padding: 24px;
  position: relative;
  transition: background-color 0.2s ease-in-out;
  width: 100%;

  :hover {
    background-color: var(--color-components-input-bg-hover-weakest);
  }

  ${Progress.S.Progress} {
    font-size: 14px;
    font-weight: 400;
    width: 100%;
  }
`;

const UploadInstructions = styled(Typography)`
  align-items: center;
  display: flex;
  gap: var(--size-4);
`;

const UploadInstructionsSpan = styled.span``;

const UploadInstruction = styled.p``;

const UploadBody = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 4px;
  justify-content: center;
`;
const UploadBodyInformation = styled.div`
  align-items: center;
  color: var(--color-neutral-800);
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  width: 146px;
`;

const UploadBodyInput = styled.input``;

const UploadBodySpan = styled.span`
  line-height: 22px;
  text-align: center;
  width: 160px;
`;

const UploadSuccess = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${Button.S.Button} {
    height: fit-content;
    margin-top: 24px;
  }
`;
const UploadSuccessIconWrapper = styled.div`
  align-items: center;
  border: 1px solid var(--color-success-default);
  border-radius: var(--size-border-radius-circle);
  color: var(--color-success-default);
  display: flex;
  height: 80px;
  justify-content: center;
  margin-bottom: 8px;
  width: 80px;

  & svg {
    transform: scale(2);

    & path {
      fill: var(--color-success-default);
    }
  }
`;
const UploadSuccessText = styled.div``;

export {
  UploadArea,
  UploadBody,
  UploadBodyInformation,
  UploadBodyInput,
  UploadBodySpan,
  UploadInput,
  UploadInstruction,
  UploadInstructions,
  UploadInstructionsSpan,
  UploadSuccess,
  UploadSuccessIconWrapper,
  UploadSuccessText,
  UploadWrapper
};
